var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "spinner" },
    [
      _c("f7-icon", {
        staticClass: "fa-spin",
        attrs: { fa: "circle-o-notch" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }